import { useQuery } from '../use-query'
import type { UseQuerySwrOptions } from '../use-query'
import type { CmsBlock, CmsBlocks, Maybe } from '@pylot-data/fwrdschema'
import { RequestInit } from '@vercel/fetch'
import { GraphQLError } from '@pylot-data/graphqlFetch'
import { getCMSBlocks } from './graphql/getCMSBlocks'

export type NavigationResponse = {
    items?: Maybe<Array<Maybe<CmsBlock | null>>>
    isValidating: boolean
    error?: GraphQLError
}

export const useCmsBlocks = (
    identifiers: string[],
    swrOptions?: UseQuerySwrOptions,
    fetchOptions?: RequestInit
): NavigationResponse => {
    const isPaused = () => identifiers.length === 0

    const { data, error, isValidating } = useQuery<
        { identifiers: string[] },
        { cmsBlocks: CmsBlocks }
    >(getCMSBlocks, { identifiers }, { ...swrOptions, isPaused }, fetchOptions)

    return {
        items: data?.data?.cmsBlocks?.items,
        isValidating,
        error
    }
}
